import axios from 'axios'

// 设置sessionId 用户身份
let sessionId = localStorage.getItem('sessionId')
axios.defaults.headers.common['sessionId'] = sessionId;
const baseUrl = '/web'
// 获取登录信息
export const showPersonalData = params => axios.get(`/userShowAbout/showPersonalData`, { params: params })
// 获取微信登录信息
export const authAccessToken = params => axios.get(`/userLoginAbout/authAccessToken`, { params: params })
// 获取手机绑定验证码
export const sendCodeAfterWeiXin = params => axios.get(`/userLoginAbout/sendCodeAfterWeiXin`, { params: params })
// 手机号绑定
export const registerAfterWeiXin = params => axios.post(`/userLoginAbout/registerAfterWeiXin`, params)

// 退出登录
export const logoutByPhone = params => axios.get(`/userLoginAbout/logoutByPhone`, { params: params })
// 手机号登录
export const loginByPhone = params => axios.post(`/userLoginAbout/loginByPhone`, params)

// **********************************************************************
// 注册
export const registerByPhone = params => axios.post(`/userLoginAbout/registerByPhone`, params)
// 注册-获取验证码
export const sendCodeByRegister = params => axios.get(`/userLoginAbout/sendCodeByRegister`, { params: params })

// **********************************************************************
// 获取头部导航
export const getTitle = params => axios.get(`/sys/title/findAll`, { params: params })
// 获取底部导航
export const getFooterTitle = params => axios.get(`/sys/footer/findAll`, { params: params })
// 获取用户角色
export const findRoleInformation = params => axios.get(`/personalCenter/findRoleInformation`, { params: params })


// 获取首页基本信息
export const getBase = params => axios.get(`/sys/main/getBase`, { params: params })
// 获取服务项目
export const getServeProject = params => axios.get(`/userAppointment/findAllServeProject`, { params: params })
// 服务类型
export const projectPriceListBySupervisorId = params => axios.get(`/userAppointment/projectPriceListBySupervisorId`, { params: params })
// 预约提交
export const appointmentSubmit = params => axios.post(`/userAppointment/insert`, params)
// 技术咨询
export const technicalCon = params => axios.post(`/sys/main/insertTechnicalConsultation`, params)

//index相关页面************************
// 加入我们******************************
export const getJoinUs = params => axios.get(`/sys/positionList/findPage`, { params: params })
// 海报
export const findJoinUsBanner = params => axios.get(`/sys/positionList/findJoinUsBanner`, { params: params })
// 岗位
export const findPositionList = params => axios.get(`/sys/positionList/findList`, { params: params })
// 提交简历
export const addRecruit = params => axios.post(`/sys/positionList/addRecruit`, params)
// 预约列表
export const findUserAppointmentList = params => axios.get(`/userAppointment/findUserAppointmentList`, { params: params })
// 监理服务
export const findSerList = params => axios.get(`/sys/serMiniAbout/findSerList`, { params: params })
// 服务banner
export const findBanner = params => axios.get(`/sys/serviceAll/findBanner`, { params: params })
// 家装监理
export const findHomeService = params => axios.get(`/sys/serviceAll/findHome`, { params: params })
// 全案管家
export const findWholecase = params => axios.get(`/sys/serviceAll/findWholecase`, { params: params })
// 案例展示
export const getCaseByTypeId = params => axios.get(`/case/getCaseByTypeId`, { params: params })
// 全程监理
export const findWholecour = params => axios.get(`/sys/serviceAll/findWholecour`, { params: params })
// 工装监理
export const findTooling = params => axios.get(`/sys/serviceAll/findTooling`, { params: params })
// 验房服务
export const findInspectionroom = params => axios.get(`/sys/serviceAll/findInspectionroom`, { params: params })
// 主题黑白**************************************
export const findDarkMode = params => axios.get(`/sys/main/findDarkMode`, { params: params })


// 基础服务-标准
export const findStandardOnMini = params => axios.get(`/sys/serMiniAbout/findStandardOnMini`, { params: params })
export const findSerWholecourseSubList = params => axios.get(`/sys/serMiniAbout/findSerWholecourseSubList`, { params: params })
export const findSerWholecourseList = params => axios.get(`/sys/serMiniAbout/findSerWholecourseList`, { params: params })

// 套餐服务-可选项
export const findOptional = params => axios.get(`/sys/serviceAll/findOptional`, { params: params })
// 户型
export const findOptionalHousing = params => axios.get(`/sys/serviceAll/findOptionalHousing`, { params: params })
export const findOptionalTiTle = params => axios.get(`/sys/serviceAll/findOptionalTiTle`, { params: params })

// 计算费用
export const insert2 = params => axios.post(`/userAppointment/insert2`, params)
export const immediatelyApp = params => axios.get(`/userAppointment/immediatelyApp`, { params: params })
// 直接预约
export const insert1 = params => axios.post(`/userAppointment/insert1`, params)
// 套餐服务 计算
export const insertOptional = params => axios.post(`/userAppointment/insertOptional`, params)
// 套餐服务 预约
export const insertOptional2 = params => axios.post(`/userAppointment/insertOptional2`, params)
export const canLookStandardDetails2 = params => axios.get(`/sys/standardDetails/canLookStandardDetails2`, { params: params })
export const findPayInfoBydetailsId = params => axios.get(`/sitePay/findPayInfoBydetailsId`, { params: params })
// 找回密码
export const sendCodeByRetrievePassword = params => axios.get(`/userLoginAbout/sendCodeByRetrievePassword`, { params: params })
export const retrievePassword = params => axios.get(`/userLoginAbout/retrievePassword`, { params: params })

// 标准查询 详情id
export const findDetailsId = params => axios.get(`/userAppointment/findDetailsId`, { params: params })
// GET 根据页面路径获取SEO
export const getSeo = params => axios.get(`/sys/seo/getSeo`, { params: params })

// 现场列表页面
export const apartmentHousingType = params => axios.get(`/sys/main/apartmentHousingType`, { params: params })
export const findSiteCommunity = params => axios.get(`/sys/main/findSiteCommunity`, { params: params })
export const findSiteDynamicNot = params => axios.get(`/sys/main/findSiteDynamicNot`, { params: params })

//服务改版2.0 - 查询 全案内容展示（新）
export const findServiceWcase = params => axios.get(`/sys/serviceAll/findServiceWcase`, { params: params })
//服务改版2.0 - 查询 全程、全案的服务对比
export const findServiceSiteContrast = params => axios.get(`/sys/serviceAll/findServiceSiteContrast`, { params: params })
//服务改版2.0 - 查询 全程内容展示（新）
export const findServiceWcourse = params => axios.get(`/sys/serviceAll/findServiceWcourse`, { params: params })
//活动列表
export const activityList = params => axios.get(`/sys/sysActivity/findPage`, { params: params })
//活动活动详情（提示，当输入的id 为null或空字符串时 显示最新的活动）
export const activityFindOneById = params => axios.get(`/sys/sysActivity/findOneById`, { params: params })
//用户 预约活动
export const toAppByActivityId = params => axios.post(`/sys/sysActivity/toAppByActivityId`, params)
// 获取全部服务项目
export const allServeProject2 = params => axios.get(`/userAppointment/allServeProject2`, { params: params })
//其他服务 - 查询其他服务的列表
export const findOtherList = params => axios.get(`/sys/serviceAll/findOtherList`, { params: params })
//其他服务 - 查询其他服务的列表
export const findOtherSubById = params => axios.get(`/sys/serviceAll/findOtherSubById`, { params: params })
/******************************关于我们**********************************/
//关于我们标题
export const aboutUsTitle = params => axios.get(`/sys/aboutUs/title`, { params: params })
//关于我们主页
export const aboutUsIndex = params => axios.get(`/sys/aboutUs/index`, { params: params })
//公司荣誉(上)
export const companyHonorTop = params => axios.get(`/sys/aboutUs/companyHonorTop`, { params: params })
//公司荣誉(下)
export const companyHonorVideo = params => axios.get(`/sys/aboutUs/companyHonorVideo`, { params: params })
//监管团队
export const team = params => axios.get(`/sys/aboutUs/team`, { params: params })


// WEBPACK FOOTER //
// ./src/api/indexApi.js